import type { AfterResponseHook } from 'ky';
import { HTTP_HEADERS } from '../../../../auth/const';
import { trackNetwork } from '../../../tracking';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const handleLogging = ({
  fetchArgs: { method, data, ..._rest },
  baseURL,
}: HookGetterArgs): AfterResponseHook => {
  const handleLoggingHook: AfterResponseHook = async (request, _opts, _response) => {
    if (isServer()) {
      const endTime = new Date().toISOString();
      const startTime = request.headers.get(HTTP_HEADERS.Timestamp);
      const { headers: nextHeaders } = await import('next/headers');
      const header = await nextHeaders();
      const serverRequestId = header.get(HTTP_HEADERS.UIServerRequestId);
      // set -1 in case startTime is not available, rare scenarios but safe handling
      const duration = startTime ? new Date(endTime).getTime() - new Date(startTime).getTime() : -1;

      const params = {
        url: baseURL,
        traceId: request.headers.get(HTTP_HEADERS.TraceId),
        timestamp: endTime,
        duration,
      };
      if (baseURL !== request.url) {
        // @ts-expect-error reqUrl is added for to debug internal url
        params.reqUrl = request.url;
      }

      if (serverRequestId) {
        params[HTTP_HEADERS.UIServerRequestId] = serverRequestId;
      }

      console.debug(`[${method}] ${baseURL} end`, { payload: data, params });
    } else {
      // track network metrics for client side requests matrix requests
      const traceId = request.headers.get(HTTP_HEADERS.TraceId);
      if (traceId) {
        const startTime = request.headers.get(HTTP_HEADERS.Timestamp);
        const endTime = new Date().toISOString();
        const duration = startTime
          ? new Date(endTime).getTime() - new Date(startTime).getTime()
          : -1;

        trackNetwork(traceId, { duration, url: baseURL });
      }
    }
  };

  return handleLoggingHook;
};
